import React, { useEffect, useState } from 'react';
import AdminPhotoGalleryCard from './AdminPhotoGalleryCard';
import { db } from '../../firebase';
import { collection, getDocs, query } from 'firebase/firestore';
import "../../css/Admin-PhotoGallery/AllPhotoGallery.css";
import UploadPhotoGallery from './UploadPhotoGallery';

const AllPhotoGallery = () => {
    const [openUploadProject, setOpenUploadProject] = useState(false);
    const [allProjects, setAllProjects] = useState([]);

    async function fetchListings() {
        try {
            const projectRef = collection(db, 'photoGallery');
            const q = query(projectRef);
            const querySnap = await getDocs(q);
            let projects = [];
            querySnap.forEach((doc) => {
                projects.push({
                    id: doc.id,
                    data: doc.data()
                });
            });
            setAllProjects(projects);
            //console.log(projects);
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        fetchListings();
    }, []);

    return (
        <div className="all-products-container">
            <div className="header-section">
                <h2 className="page-title">All Images</h2>
                <button
                    className="upload-button"
                    onClick={() => setOpenUploadProject(true)}
                >
                    Upload Images
                </button>
            </div>

            <div className="products-list">
                {allProjects.map((project) => (
                    <AdminPhotoGalleryCard
                        data={project.data}
                        projectKey={project.id}
                        fetchData={fetchListings}
                    />
                ))}
            </div>

            {/* upload product component */}
            {
                openUploadProject && (
                    <UploadPhotoGallery onClose={()=>setOpenUploadProject(false)} fetchData={fetchListings}/>
                )
            }
        </div>
    );
};

export default AllPhotoGallery;
